import * as server from '../entries/pages/_page.server.ts.js';

export const index = 2;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/_page.svelte.js')).default;
export { server };
export const server_id = "src/routes/+page.server.ts";
export const imports = ["_app/immutable/nodes/2.ffa50ac3.js","_app/immutable/chunks/scheduler.349e619f.js","_app/immutable/chunks/index.b97ce8f1.js","_app/immutable/chunks/Loading.a5966771.js","_app/immutable/chunks/index.e9bbedad.js"];
export const stylesheets = ["_app/immutable/assets/2.420c4a59.css","_app/immutable/assets/Loading.218e0f39.css"];
export const fonts = [];
